import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
  header_msg: string;
  header_msg_description: string | string[];
  cancel_action: string;
  ok_action: string;
}

@Component({
  selector: 'app-admin-dialog',
  templateUrl: './admin-dialog.component.html',
  styleUrl: './admin-dialog.component.css',
})
export class AdminDialogComponent {
  message : string[]=[]
  constructor(
    public dialogRef: MatDialogRef<AdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (typeof data.header_msg_description === 'string') {
      this.message = [data.header_msg_description];
    } else {
      this.message = data.header_msg_description;
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
